import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBDateField } from '_components';
import { getDateMMDDYYYY } from '_helpers';
import styles from './Common.module.css';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';

class PatientCareCenterNoteGoalsGoalDetailsWCEvalCustom extends React.Component {

    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', true);
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            this.props.activityName !== prevProps.activityName &&
            this.props.goal.GOGOALLEVEL &&
            !(Object.keys(this.props.goalLevels).map(key => this.props.goalLevels[key].id)).includes(this.props.goal.GOGOALLEVEL)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGOALLEVEL');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            this.props.activityName !== prevProps.activityName &&
            this.props.goal.GOCLOF &&
            !(Object.keys(this.props.clofGoalLevels).map(key => this.props.clofGoalLevels[key].id)).includes(this.props.goal.GOCLOF)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOCLOF');
        }
    }

    render() {
        return (
            <PatientCareCenterNoteNavAnchor id={'goal_' + this.props.goal.GONO} >
                <div className={styles.goal_detail_wrapper}>
                    <div className={styles.goal_detail_row_wc}>
                        <span className={styles.goal_detail_col1}>
                            <CancelButton title='Delete Goal' size='extra-small' onClick={() => this.deleteGoal()} />
                        </span>
                        {/* Activity */}
                        <div className={styles.goal_detail_col2_pd_wc}>
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOCUSTOM'
                                className={styles.goal_level_dropdown_wc}
                            />
                        </div>
                        {/* PLOF */}
                        <div className={styles.goal_detail_col3_pd_wc}>
                            <DBDropDown
                                className={styles.goal_level_dropdown_wc}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOPLOF'
                                customOptions={this.props.goalLevels}
                            />
                        </div>
                        {/* CLOF */}
                        <div className={styles.goal_detail_col4_pd_wc}>
                            <DBDropDown
                                className={styles.goal_level_dropdown_wc}
                                noteId={this.props.noteId}
                                entity='PTGOALS' s
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOCLOF'
                                customOptions={this.props.clofGoalLevels}
                                placeholder='Current Ability'
                            />
                        </div>
                        {/* GOAL */}
                        <div className={styles.goal_detail_col5_pd_wc}>
                            <DBDropDown
                                className={styles.goal_level_dropdown_wc}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOGOALLEVEL'
                                customOptions={this.props.goalLevels}
                            />
                        </div>
                        {/* DATE */}
                        <div className={styles.goal_detail_col6_pd_wc}>
                            <DBDateField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GODATE'
                                customMsg='The goal date cannot be in the past.'
                                minDate={getDateMMDDYYYY(new Date())}
                            />
                        </div>

                    </div>
                    <div className={styles.goal_detail_row_wc}>
                        <div className={styles.goal_detail_col8_pd_wc}>
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOOBJECTIVE'
                                className={styles.text_field}
                                placeholder='Describe how the patient is performing the activity today.'
                            />
                        </div>
                    </div>
                </div>
            </PatientCareCenterNoteNavAnchor>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let activityName = goal.GOMGNO ? state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : '';
    let goalLevelSentence = goal.GOGOALLEVEL ? state.entities.masterData.PTMASTERGOALLEVELS[goal.GOGOALLEVEL].GLSENTENCETXT : '';
    let pdc = undefined;
    if (noteType === 1 && state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC) {
        pdc = state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC;
    } else {
        pdc = state.entities.admissions[epno].jobReqPdc;
    }

    let clofGoalLevels = [];
    if (goal.GOMGNO) {
        // get based on XREF
        let glnos = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
            .filter(key => {
                return (state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO);
            })
            .map(key => state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO);

        clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
            .filter(key => {
                return (glnos.includes(state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO));
            })
            .sort((a, b) => {
                let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                    });
                let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

                let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                    });
                let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

                return aOrder - bOrder;
            })
            .map(key => {
                return {
                    id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                    value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                    sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                    clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
                }
            })
    }

    let goalLevels = Object.keys(clofGoalLevels)
        .filter(key => {
            return clofGoalLevels[key].clofOnly === false;
        })
        .map(key => {
            return clofGoalLevels[key];
        });

    let mgnos = Object.keys(state.entities.masterData.PTMASTERGOALPDCXREF)
        .filter(key => {
            return (state.entities.masterData.PTMASTERGOALPDCXREF[key].GPXWPNO === pdc);
        })
        .map(key => state.entities.masterData.PTMASTERGOALPDCXREF[key].GPXMGNO);



    let masterGoals = Object.keys(state.entities.masterData.PTMASTERGOALS)
        .filter(key => {
            return mgnos.includes(state.entities.masterData.PTMASTERGOALS[key].MGNO) &&
                state.entities.masterData.PTMASTERGOALS[key].MGWORKCOMP === true;
        })
        .sort((a, b) => {
            return state.entities.masterData.PTMASTERGOALS[a].MGORDER - state.entities.masterData.PTMASTERGOALS[b].MGORDER;
        })
        .map(key => {
            return {
                id: state.entities.masterData.PTMASTERGOALS[key].MGNO,
                value: state.entities.masterData.PTMASTERGOALS[key].MGNAME,
            }
        })


    return {
        noteId,
        noteType,
        pk,
        goal,
        masterGoals,
        activityName,
        goalLevelSentence,
        clofGoalLevels,
        goalLevels,
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsWCEvalCustom = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalDetailsWCEvalCustom);
export { connectedPatientCareCenterNoteGoalsGoalDetailsWCEvalCustom as PatientCareCenterNoteGoalsGoalDetailsWCEvalCustom };

